<template>
  <section class="login-wrapper">
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="container mt-4">
      <h2 class="text-center">
        รายการบันทึกการตรวจสอบ
        <b class="text-danger-emphasis">ห้องควบคุมอุณหภูมิ</b>
      </h2>
      <h3 class="text-center mb-4">#{{ code }}</h3>

      <div class="text-center">
        <button
          class="btn btn-warning border-dark btn-lg mb-3"
          @click="openFormModal"
        >
          เพิ่มบันทึกการตรวจสอบ
        </button>
      </div>

      <!-- <div class="card mb-3">
        <div class="card-body">
          <ChartRoomTemperature :key="chartKey" />
        </div>
      </div> -->

      <div class="card mb-3">
        <div class="card-body">
          <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
            <div class="input-group">
              <select v-model="selectedMonth" class="form-select" required>
                <option value="" disabled selected>- เลือกเดือน -</option>
                <option
                  v-for="month in months"
                  :key="month.value"
                  :value="month.value"
                >
                  {{ month.name }}
                </option>
              </select>
              <select v-model="selectedYear" class="form-select ms-2" required>
                <option value="" disabled>- เลือกปี -</option>
                <option v-for="year in years" :key="year" :value="year">
                  {{ year + 543 }}
                </option>
              </select>
              <button
                @click.prevent="clearFilters"
                class="btn btn-secondary"
                type="button"
              >
                <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
              </button>
            </div>
          </form>

          <div class="position-relative">
            <LoadingOverlay :show="loading" />
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="table-dark text-center">
                  <tr>
                    <th>วันเวลาที่บันทึก</th>
                    <th>ช่วงเวลา</th>
                    <th>ชื่อผู้บันทึก</th>
                    <th>ชื่อหน่วยงาน</th>
                    <th>รหัส-ชื่อ</th>
                    <th>อุณหภูมิ (°C)</th>
                    <th>ความชื้น</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!filteredRecords.length">
                    <td class="text-center text-muted" colspan="7">No data</td>
                  </tr>
                  <tr v-for="record in filteredRecords" :key="record.id">
                    <td>
                      {{ formatRecordDate(record.record_date) }} |
                      {{ record.record_time }}
                    </td>
                    <td>{{ record.shift_type?.name }}</td>
                    <td>{{ record.recorder }}</td>
                    <td>{{ record.group?.name }}</td>
                    <td>
                      {{ record.room_temperature?.code }} -
                      {{ record.room_temperature?.name }}
                    </td>
                    <td>{{ record.temperature }}</td>
                    <td>{{ record.humidity }}</td>
                  </tr>
                </tbody>
              </table>

              <hr />
              <h4 class="text-center">ตารางสรุปรายวันแบบปฏิทิน</h4>
              <div class="table-responsive">
                <table class="table table-bordered text-center">
                  <thead class="table-dark">
                    <tr>
                      <th>ช่วงเวลา</th>
                      <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="shift in shiftLabels" :key="shift">
                      <th class="text-start">{{ shift }}</th>
                      <td v-for="day in daysInMonth" :key="day">
                        <div
                          v-if="
                            recordsByDayShift[shift] &&
                            recordsByDayShift[shift][day]
                          "
                        >
                          ✅
                          <!-- Optional: show detail -->
                          <!-- <div>{{ recordsByDayShift[shift][day].recorder }}</div> -->
                        </div>
                        <div v-else>-</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for inserting form data -->
      <div
        class="modal fade"
        id="Modal"
        tabindex="-1"
        data-bs-backdrop="static"
        aria-labelledby="roleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">บันทึกการตรวจสอบอุณหภูมิห้อง</h5>
              <button
                type="button"
                class="btn-close"
                @click="closeFormModal"
              ></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="handleSubmit">
                <div class="row" v-if="showRecordDateTime">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >วันที่บันทึก (Record Date)</label
                      >
                      <DatePicker v-model="form.record_date" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">เวลา (Record Time)</label>
                      <TimePicker v-model="form.record_time" required />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">หน่วยงาน (Department)</label>
                  <select
                    disabled
                    v-model="form.group_id"
                    class="form-select"
                    required
                  >
                    <option
                      v-for="dept in groups"
                      :key="dept.id"
                      :value="dept.id"
                    >
                      {{ dept.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">อุณหภูมิ (Temperature °C)</label>
                  <input
                    type="number"
                    step="0.1"
                    v-model="form.temperature"
                    class="form-control"
                    placeholder="อุณหภูมิ"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">ความชื้น (Humidity)</label>
                  <input
                    type="number"
                    step="0.1"
                    v-model="form.humidity"
                    class="form-control"
                    placeholder="ความชื้น"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">กะงาน (Shift Type)</label>
                  <select
                    v-model="form.shift_type_id"
                    class="form-select"
                    required
                  >
                    <option disabled value="">- เลือกกะงาน -</option>
                    <option
                      v-for="shift in shiftTypes"
                      :key="shift.id"
                      :value="shift.id"
                    >
                      {{ shift.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                  <v-select
                    v-model="form.recorder"
                    :options="doctors"
                    label="name"
                    :reduce="(item) => item.name"
                    :clearable="false"
                    placeholder="ค้นหา..ชื่อผู้บันทึก"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.recorder"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </div>
                <hr />
                <button type="submit" class="btn btn-lg btn-primary w-100">
                  บันทึกข้อมูล (Save)
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";

import axiosInstance from "@/utils/axiosInstance";
import { showErrorAlert, showSuccessAlert } from "@/utils/sweetalert2-utils";
// import DateTimePicker from '../../components/DateTimePicker.vue';
// import ChartRoomTemperature from "@/components/ChartRoomTemperature.vue";
import DatePicker from "@/components/DatePicker.vue";
import TimePicker from "@/components/TimePicker.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { useShowRecordDateTime } from "@/utils/recordSettings";

const { showRecordDateTime } = useShowRecordDateTime();

// function formatDateTimeUTC(date) {
//   const m = moment.utc(date).locale('th');
// //   const buddhistYear = m.year() + 543;
//   const formatted = m.format('D MMM HH:mm');
//   return `${formatted}`;
// }

// === Reactive Variables ===
const today = new Date();
const selectedMonth = ref(today.getMonth() + 1);
const selectedYear = ref(today.getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i); // 5 ปีย้อนหลัง
const modal = ref(null);
const records = ref([]);
const loading = ref(false);
const groups = ref([]);
const shiftTypes = ref([]);
const chartKey = ref(0);
const doctors = ref([]);

const now = moment().format("YYYY-MM-DD HH:mm:ss");
const [dateStr, timeStr] = now.split(" ");

const date = ref(dateStr);
const time = ref(timeStr);

const form = ref({
  group_id: "",
  room_temperature_id: "",
  recorder: "",
  temperature: "",
  humidity: "",
  shift_type_id: "",
  record_date: date.value, // ✅ already present
  record_time: time.value, // ✅ already present
});

const route = useRoute();
const code = ref(route.params.code);

function formatRecordDate(dateStr) {
  const m = moment(dateStr, "YYYY-MM-DD").locale("th");
  const buddhistYear = m.year() + 543;
  const month = m.format("MMM");
  const day = m.format("D");
  return `${day} ${month} ${String(buddhistYear).slice(2)}`; // ได้รูปแบบ '4 มิ.ย. 68'
}

// === Constants ===
const months = [
  { value: 1, name: "มกราคม" },
  { value: 2, name: "กุมภาพันธ์" },
  { value: 3, name: "มีนาคม" },
  { value: 4, name: "เมษายน" },
  { value: 5, name: "พฤษภาคม" },
  { value: 6, name: "มิถุนายน" },
  { value: 7, name: "กรกฎาคม" },
  { value: 8, name: "สิงหาคม" },
  { value: 9, name: "กันยายน" },
  { value: 10, name: "ตุลาคม" },
  { value: 11, name: "พฤศจิกายน" },
  { value: 12, name: "ธันวาคม" },
];

const shiftLabels = ["ดึก", "เช้า", "บ่าย"];

// === Computed Properties ===
const daysInMonth = computed(() => {
  return Array.from(
    { length: new Date(selectedYear.value, selectedMonth.value, 0).getDate() },
    (_, i) => i + 1
  );
});

// import moment from 'moment-timezone';

const filteredRecords = computed(() => {
  return records.value.filter((record) => {
    const recordDate = moment(record.record_date, "YYYY-MM-DD");
    return (
      record.room_temperature.code === code.value &&
      recordDate.month() + 1 === Number(selectedMonth.value) &&
      recordDate.year() === Number(selectedYear.value)
    );
  });
});

const recordsByDayShift = computed(() => {
  const map = {};
  for (const record of filteredRecords.value) {
    const day = moment(record.record_date, "YYYY-MM-DD").date();
    const shift = record.shift_type?.name;
    if (!map[shift]) map[shift] = {};
    map[shift][day] = record;
  }
  return map;
});

// function formatDateTimeUTC(dateStr) {
//   const m = moment.utc(dateStr).locale("th");
//   const buddhistYear = m.year() + 543;
//   const month = m.format("MMM");
//   const day = m.format("D");
//   return `${day} ${month} ${String(buddhistYear).slice(2)}`; // ได้รูปแบบ '4 มิ.ย. 68'
// }

function clearFilters() {
  selectedMonth.value = today.getMonth() + 1;
  selectedYear.value = today.getFullYear();
}

// === Toast Configuration ===
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

// === API Methods ===
const fetchDataCode = async () => {
  try {
    const response = await axiosInstance.get(
      `/check_room_temperature/${code.value}`
    );
    form.value = {
      group_id: response.data.group_id,
      room_temperature_id: response.data.id,
      recorder: "",
      temperature: "",
      humidity: "",
      shift_type_id: "",
    };

    fetchData(response.data.id);
  } catch {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

const fetchData = async (id) => {
  loading.value = true;
  try {
    const [recordsRes, deptRes, shiftRes] = await Promise.all([
      axiosInstance.get(`/room_temperature_record/room_temperature/${id}`),
      axiosInstance.get("/group"),
      axiosInstance.get("/shift_type"),
    ]);

    records.value = recordsRes.data;
    groups.value = deptRes.data;
    shiftTypes.value = shiftRes.data;

    const currentDate = new Date().toISOString().split("T")[0];
    const todayRecord = recordsRes.data.find((record) => {
      return (
        record.record_date === currentDate &&
        record.room_temperature.code === code.value
      );
    });

    Toast.fire({
      icon: todayRecord ? "success" : "error",
      title: todayRecord
        ? "บันทึกแล้ว ในวันนี้!"
        : "ยังไม่บันทึกแล้ว ในวันนี้!",
    });
  } catch (error) {
    console.error("Error fetching data:", error);
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  } finally {
    loading.value = false;
  }
};

const getDoctors = async () => {
  try {
    const res = await axios.get(
      "https://api-hos.wanorn.com/backend/api/doctor"
    );
    doctors.value = res.data.filter((doctor) => doctor.active !== "N");
  } catch (error) {
    console.error("Error fetching data:", error);
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

const handleSubmit = async () => {
  try {
    form.value.record_time = moment(form.value.record_time, "HH:mm").format(
      "HH:mm:ss"
    );

    await axiosInstance.post("/room_temperature_record", form.value);
    showSuccessAlert("บันทึกเรียบร้อยแล้ว!");
    // fetchData();
    fetchDataCode();
    hideModal();
    chartKey.value += 1;
  } catch {
    showErrorAlert("Error saving record");
  }
};

// === Modal Methods ===
const showModal = () => modal.value.show();
const hideModal = () => modal.value.hide();

const openFormModal = () => {
  const now = moment(); // <-- this is now a moment object
  form.value.record_date = now.format("YYYY-MM-DD");
  form.value.record_time = now.format("HH:mm:ss");

  showModal();
};
const closeFormModal = () => hideModal();

// === Lifecycle Hook ===
onMounted(() => {
  getDoctors();
  // fetchData();
  fetchDataCode();
  modal.value = new Modal(document.getElementById("Modal"));
});
</script>

<style scoped>
.login-wrapper {
  display: flex;
  height: 100vh;
}

.material-half-bg {
  flex: 1;
}

.login-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover {
  background: url("https://api.mespace-selfstorage.co.th/images/uploads/2022/09/rent-a-temperature-controlled-storage-4.jpg")
    no-repeat center center;
  background-size: cover;
  height: 100%;
  opacity: 0.5;
}
</style>
